/**
 * @author Jorge Casas
 * @creationDate 01/07/2024
 */

import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Form } from 'common/components';
import { generateCodesLabelByAssetPDF } from 'lib/pdfs/AssetsCodesLabel';
import { generateCodesLabelByAssetDocx } from 'lib/documents/AssetsCodesLabel';
import { generateCombinedImage } from 'lib/images/AssetsCodesLabel';
import { getCodesLabelsByAssetPDFReport } from 'containers/assets/actions';
import { addGrowlError } from 'messages/actions';
import { downloadImageFromUrl } from 'lib/images/downloadImage';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getPagination,
  getIsLoading,
  getVisibleAssets,
  getFilters,
  getNeedFetch,
} from 'selectors/reports_depreciation';
import {
  getVisibleAccountsParent,
  getVisibleCostCenters,
  getVisibleEmployees,
  getVisibleStatus,
} from 'selectors/lists';

class AssetDetailCodesLabel extends Component {
  constructor(props) {
    super(props);
    this.handleExportCodesLabelByAssetPDF = this.handleExportCodesLabelByAssetPDF.bind(this);
  }

  handleExportCodesLabelByAssetPDF = async (e) => {
    const { asset } = this.props;
    try {
      const test = await generateCodesLabelByAssetPDF(asset.qrUrl, asset.barcodeUrl);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  handleExportCodesLabelByAssetDocx = async (e) => {
    const { asset } = this.props;
    try {
      const test = await generateCodesLabelByAssetDocx(
        asset.qrUrl,
        asset.barcodeUrl,
        `${asset.number}.docx`
      );
    } catch (error) {
      console.error('Error generating DOCX:', error);
    }
  };

  handleExportCodesLabelByAssetImage = async (e) => {
    const { asset } = this.props;
    try {
      const test = await generateCombinedImage(
        asset.qrUrl,
        asset.barcodeUrl,
        `${asset.number}.png`
      );
    } catch (error) {
      console.error('Error generating image:', error);
    }
  };

  // QR and barcode as separate files, without touching the combined PNG.
  // Direct fetch to S3, NOT /download-file-and-convert-to-base64 (SSRF).
  handleDownloadSingleCode = async (url, filename) => {
    try {
      await downloadImageFromUrl(url, filename);
    } catch (error) {
      console.error('Error downloading image:', error);
      this.props.addGrowlError('error.download_image');
    }
  };

  render() {
    const { t } = this.props;

    return (
      <Form.Section>
        <br />
        <br />
        <div className="row">
          <div className="col-sm-2 col-md-3 col-lg-3"></div>
          <div className="col-sm-8 col-md-6 col-lg-6 text-center">
            <h5>{t('assets.section.codes.codeLabel')}</h5>
            <br />
            <div className="d-flex justify-content-center" style={{ alignItems: 'center' }}>
              <button
                type="button"
                className="btn btn-info ml-2 mr-2"
                onClick={this.handleExportCodesLabelByAssetPDF}
              >
                {t('assets.section.codes.format.pdf')}
              </button>
              <button
                type="button"
                className="btn btn-info ml-2 mr-2"
                onClick={this.handleExportCodesLabelByAssetDocx}
              >
                {t('assets.section.codes.format.docx')}
              </button>
              <button
                type="button"
                className="btn btn-info ml-2 mr-2"
                onClick={this.handleExportCodesLabelByAssetImage}
              >
                {t('assets.section.codes.format.png')}
              </button>
              <button
                type="button"
                className="btn btn-info ml-2 mr-2"
                onClick={() =>
                  this.handleDownloadSingleCode(
                    this.props.asset.qrUrl,
                    `${this.props.asset.number}-qr.png`
                  )
                }
              >
                {t('assets.section.codes.format.png_qr')}
              </button>
              <button
                type="button"
                className="btn btn-info ml-2 mr-2"
                onClick={() =>
                  this.handleDownloadSingleCode(
                    this.props.asset.barcodeUrl,
                    `${this.props.asset.number}-barcode.png`
                  )
                }
              >
                {t('assets.section.codes.format.png_barcode')}
              </button>
            </div>
          </div>
          <div className="col-sm-2 col-md-3 col-lg-3"></div>
        </div>
      </Form.Section>
    );
  }
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  isLoading: getIsLoading(state),
  pagination: getPagination(state),
  permissions: getPermissions(state),
  assets: getVisibleAssets(state),
  filters: getFilters(state),
  needFetch: getNeedFetch(state),
  accounts: getVisibleAccountsParent(state),
  costCenters: getVisibleCostCenters(state),
  employees: getVisibleEmployees(state),
  status: getVisibleStatus(state),
});

const mapDispatchToProps = {
  getCodesLabelsByAssetPDFReport,
  addGrowlError,
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(AssetDetailCodesLabel));



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/AssetDetailCodesLabel.js